var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"tel"},domProps:{"value":_vm.formattedValue},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }